// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue'
import type { RouteRecordRaw } from 'vue-router';
import {roterPre} from "@/settings";

const marketingRouter =
{
  path:  roterPre+`/marketing`,
  name: 'marketing',
  meta: {
    title: '营销'
  },
  alwaysShow: true,
  component: Layout,
  redirect: 'noRedirect',
  children: [
    {
      path: 'coupon',
      name: 'Coupon',
      meta: {
        title: '优惠券',
        noCache: true
      },
      // redirect: 'noRedirect',
      component: () => import('@/views/marketing/coupon/index.vue'),
      children: [
        {
          path: 'list',
          name: 'CouponList',
          meta: {
            title: '优惠劵列表',
            noCache: true
          },
          component: () => import('@/views/marketing/coupon/couponList/index.vue')
        },
        {
          path: 'user',
          name: 'CouponUser',
          meta: {
            title: '优惠券领取记录',
            noCache: true
          },
          component: () => import('@/views/marketing/coupon/couponUser/index.vue')
        },
        {
          path: 'creatCoupon/:id?',
          name: 'CreatCoupon',
          meta: {
            title: '添加优惠劵',
            noCache: true,
            activeMenu: `/merchant/marketing/coupon/list`
          },
          component: () => import('@/views/marketing/coupon/couponList/creatCoupon.vue')
        },
        {
          path: 'send',
          name: 'CouponSend',
          meta: {
            title: '优惠券发送记录',
            noCache: true
          },
          component: () => import('@/views/marketing/coupon/couponSend/index.vue')
        }
      ]
    },
    /*{
      path: 'studio',
      name: 'Studio',
      meta: {
        title: '直播间',
        noCache: true
      },
      redirect: 'noRedirect',
      component: () => import('@/views/multi/marketing/studio/index.vue'),
      children: [
        {
          path: 'list',
          name: 'StudioList',
          meta: {
            title: '直播间管理',
            noCache: true
          },
          component: () => import('@/views/multi/marketing/studio/studioList/index.vue')
        },
        {
          path: 'creatStudio',
          name: 'CreatStudio',
          meta: {
            title: '创建直播间',
            noCache: true,
            activeMenu: `/merchant/marketing/studio/list`
          },
          component: () => import('@/views/multi/marketing/studio/studioList/creatStudio.vue')
        },
        {
          path: 'assistant',
          name: 'AssistantStudio',
          meta: {
            title: '直播助手',
            noCache: true
          },
          component: () => import('@/views/multi/marketing/studio/assistant/index.vue')
        }
      ]
    },
    {
      path: 'broadcast',
      name: 'Broadcast',
      meta: {
        title: '直播',
        noCache: true
      },
      redirect: 'noRedirect',
      component: () => import('@/views/multi/marketing/broadcast/index.vue'),
      children: [
        {
          path: 'list',
          name: 'BroadcastList',
          meta: {
            title: '直播商品管理',
            noCache: true
          },
          component: () => import('@/views/multi/marketing/broadcast/broadcastList/index.vue')
        },
        {
          path: 'addProduct',
          name: 'BroadcastProduct',
          meta: {
            title: '创建直播商品',
            noCache: true,
            activeMenu: `/merchant/marketing/broadcast/list`
          },
          component: () => import('@/views/multi/marketing/broadcast/broadcastList/addProduct.vue')
        }
      ]
    },
    {
      path: 'seckill',
      name: 'Seckill',
      meta: {
        title: '秒杀管理',
        noCache: true
      },
      redirect: 'noRedirect',
      component: () => import('@/views/multi/marketing/seckill/index.vue'),
      children: [
        {
          path: 'product/list',
          name: 'SpikeGoods',
          meta: {
            title: '秒杀商品',
            noCache: true
          },
          component: () => import('@/views/multi/marketing/seckill/seckillGoods/index.vue')
        },
        // {
        //   path: 'createGoods/:id',
        //   name: 'CreateSpikeGoods',
        //   meta: {
        //     title: '添加秒杀商品',
        //     noCache: true,
        //     activeMenu: `/merchant/marketing/seckill/list`
        //   },
        //   component: () => import('@/views/multi/marketing/seckill/seckillGoods/createGoods.vue')
        // },
        {
          path: 'store_seckill/list',
          name: 'SeckillActivity',
          meta: {
            title: '秒杀活动',
            noCache: true
          },
          component: () => import('@/views/multi/marketing/seckill/store_seckill/index.vue')
        },
        {
          path: 'store_seckill/join/:id?/:type?',
          name: 'JoinSeckillActivity',
          meta: {
            title: '参与秒杀活动',
            noCache: true,
            activeMenu: `/merchant/marketing/seckill/store_seckill/list`
          },
          component: () => import('@/views/multi/marketing/seckill/store_seckill/join_activity.vue')
        },
        {
          path: 'store_seckill/statistics/:id?',
          name: 'SeckillStatistics',
          meta: {
            title: '秒杀活动统计',
            noCache: true,
            activeMenu: `/merchant/marketing/seckill/store_seckill/list`
          },
          component: () => import('@/views/multi/marketing/seckill/store_seckill/statistics.vue')
        },
      ]
    },
    {
      path: 'presell',
      name: 'preSell',
      meta: {
        title: '预售商品管理',
        noCache: true
      },
      redirect: 'noRedirect',
      component: () => import('@/views/multi/marketing/seckill/index.vue'),
      children: [
        {
          path: 'list',
          name: `preSaleList`,
          meta: {
            title: '预售商品',
            noCache: true
          },
          component: () => import('@/views/multi/marketing/preSale/index.vue')
        },
        {
          path: 'create/:id?/:edit?',
          name: `preSaleCreate`,
          meta: {
            title: '添加预售商品',
            noCache: true,
            activeMenu: `/merchant/marketing/presell/list`
          },
          component: () => import('@/views/multi/marketing/preSale/create.vue')
        }
      ]
    },
    {
      path: 'assist',
      name: 'assist',
      meta: {
        title: '助力活动商品',
        noCache: true
      },
      redirect: 'noRedirect',
      component: () => import('@/views/multi/marketing/seckill/index.vue'),
      children: [
        {
          path: 'list',
          name: `assistProductList`,
          meta: {
            title: '助力活动商品',
            noCache: true
          },
          component: () => import('@/views/multi/marketing/assist/assist_list/index.vue')
        },
        {
          path: 'create/:id?/:edit?',
          name: `assistProductCreate`,
          meta: {
            title: '添加助力活动商品',
            noCache: true,
            activeMenu: `/merchant/marketing/assist/list`
          },
          component: () => import('@/views/multi/marketing/assist/assist_list/create.vue')
        },
        {
          path: 'assist_set',
          name: `assistSet`,
          meta: {
            title: '助力活动列表',
            noCache: true
          },
          component: () => import('@/views/multi/marketing/assist/assist_activity/index.vue')
        }
      ]
    },
    {
      path: 'combination',
      name: 'combinAtion',
      meta: {
        title: '拼团管理',
        noCache: true
      },
      redirect: 'noRedirect',
      component: () => import('@/views/multi/marketing/combination/index.vue'),
      children: [
        {
          path: 'combination_goods',
          name: `combinationGoods`,
          meta: {
            title: '拼团商品',
            noCache: true
          },
          component: () => import('@/views/multi/marketing/combination/combination_goods/index.vue')
        },
        {
          path: 'combination_list',
          name: `combinationLoods`,
          meta: {
            title: '拼团列表',
            noCache: true
          },
          component: () => import('@/views/multi/marketing/combination/store_combination/index.vue')
        },
        {
          path: 'create/:id?/:edit?',
          name: `combinationCreate`,
          meta: {
            title: '添加拼团商品',
            noCache: true,
            activeMenu: `/merchant/marketing/combination/combination_goods`
          },
          component: () => import('@/views/multi/marketing/combination/combination_goods/create.vue')
        }
      ]
    },
    {
      path: 'integral',
      name: 'integral',
      meta: {
        title: '积分',
        noCache: true
      },
      redirect: 'noRedirect',
      component: () => import('@/views/multi/marketing/integral/index.vue'),
      children: [
        {
          path: 'config',
          name: `integralConfig`,
          meta: {
            title: '积分配置',
            noCache: true
          },
          component: () => import('@/views/multi/marketing/integral/config/index.vue')
        },
        {
          path: 'log',
          name: `integralLog`,
          meta: {
            title: '积分记录',
            noCache: true
          },
          component: () => import('@/views/multi/marketing/integral/log/index.vue')
        }
      ]
    },
    {
      path: 'discounts',
      name: 'discounts',
      meta: {
        title: '套餐',
        noCache: true
      },
      redirect: 'noRedirect',
      component: () => import('@/views/multi/marketing/integral/index.vue'),
      children: [
        {
          path: 'list',
          name: `discountsList`,
          meta: {
            title: '套餐列表',
            noCache: true
          },
          component: () => import('@/views/multi/marketing/discounts/index.vue')
        },
        {
          path: 'create/:id?/:edit?',
          name: `discountsCreate`,
          meta: {
            title: '添加套餐',
            noCache: true,
            activeMenu: `/merchant/marketing/discounts/list`
          },
          component: () => import('@/views/multi/marketing/discounts/create.vue')
        }
      ]
    },*/
  ]
}

export default marketingRouter as RouteRecordRaw